


type UnitCategory = 
    'Volume'
    | 'Pressure'
    | 'Flow Rate'
    | 'Temperature'
    | 'Humidity'
    | 'Water Treatment / Environmental Monitoring'
    | 'Water Quality'
    | 'Air Quality'
    | 'Tank Monitoring'
    | 'Turbine Speed'
    | 'Wind Speed'
    | 'Miscellaneous';


interface UnitEntry {
    value: string
    category: UnitCategory
}

interface Units {
    [unitCode: string]: UnitEntry;
}

export const inputUnits: Units = {
    "01": {
        value: "Litres",
        category: 'Volume'
    },
    "02": {
        value: "m³",
        category: "Volume"
    },
    "03": {
        value: "Bar",
        category: 'Pressure'
    },
    "04": {
        value: "mbar",
        category: 'Pressure'
    },
    "05": {
        value: "mH₂O",
        category: 'Pressure'
    },
    "06": {
        value: "PSI",
        category: 'Pressure'
    },
    "07": {
        value: " US Gallons",
        category: 'Volume'
    },
    "08": {
        value: "ft³",
        category: 'Volume'
    },
    "09": {
        value: "l/s",
        category: 'Flow Rate'
    },
    "10": {
        value: "m³/h",
        category: 'Flow Rate'
    },
    "11": {
        value: "Ml/d",
        category: 'Flow Rate'
    },
    "12": {
        value: "kPa",
        category: 'Pressure'
    },
    "13": {
        value: "ftH₂O",
        category: 'Pressure'
    },
    "14": {
        value: "kg/cm²",
        category: 'Pressure'
    },
    //"15": {
    //    value: "mm",
    //    category: "Level / Depth"
    //},
    //"16": {
    //    value: "cm",
    //    category: "Level / Depth"
    //},
    "17": {
        value: "°C",
        category: 'Temperature'
    },
    "18": {
        value: "°F",
        category: "Temperature"
    },
    "19": {
        value: "%RH",
        category: "Humidity"
    },
    "20": {
        value: "pH",
        category: "Water Treatment / Environmental Monitoring"
    },
    "21": {
        value: "μS/cm",
        category: "Water Quality"
    },
    "22": {
        value: "mS/cm",
        category: "Water Quality"
    },
    "23": {
        value: "S/cm",
        category: "Water Quality"
    },
    "24": {
        value: "TDS ppm",
        category: "Water Quality"
    },
    "25": {
        value: "TDS mg/L",
        category: "Water Quality"
    },
    "26": {
        value: "NTU",
        category: "Water Quality"
    },
    "27": {
        value: "FTU",
        category: "Water Quality"
    },
    "28": {
        value: "mg/l",
        category: "Water Quality"
    },
    "29": {
        value: "ppm solids",
        category: "Water Quality"
    },
    "30": {
        value: "ppm",
        category: "Water Quality"
    },
    "31": {
        value: "% saturation",
        category: "Water Quality"
    },
    "32": {
        value: "ppb",
        category: "Water Quality"
    },
    "33": {
        value: "% vol",
        category: "Air Quality"
    },
    "34": {
        value: "% full",
        category: "Tank Monitoring"
    },
    "35": {
        value: "RPM",
        category: "Turbine Speed"
    },
    "36": {
        value: "m/s",
        category: "Wind Speed"
    },
    "37": {
        value: "%",
        category: "Miscellaneous"
    }
}